import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { IPage } from "@zaeper/communication-lib";
import {
  ILauncherVersionRestClient
} from "../../../../rest-clients/application-version/launcher-version/i-launcher-version-rest.client";
import {
  launcherVersionRestClientInjectionToken
} from "../../../../rest-clients/application-version/launcher-version/launcher-version-rest-client-injection-token";
import { ILauncherVersion } from "../../../../models/application-version/i-launcher-version";

@Injectable()
export class LauncherVersionPageResolver implements Resolve<IPage<ILauncherVersion>> {
  constructor( @Inject( launcherVersionRestClientInjectionToken ) private readonly _launcherVersionRestClient: ILauncherVersionRestClient ) {
  }

  resolve( route: ActivatedRouteSnapshot ): Promise<IPage<ILauncherVersion>> {
    const launcherId: string | null = route.paramMap.get( 'launcherId' );

    if ( launcherId === null ) {
      return Promise.reject();
    }

    return this._launcherVersionRestClient.getLauncherVersionPage( launcherId, {
      pageNumber: 0,
      pageSize: 100
    } );
  }
}
